import cleanDeep from 'clean-deep';
import React from 'react';
import { connect } from 'react-redux';

import Select from 'react-select'
import { Actions as ACTIONS } from '../../../store/actions/leaveActions';
import { validateInteger } from '../../common/validation/Validators';

const SickNotificationPeriod = ({ sickNotification, updateSetting, disabled, departmentOptions, filteredDepartmentOptions }) => {
    return (
        <div className="col-lg-12 form-container">
            <div className="col-sm-4 pl-0">
                <div className="form-material">
                    {sickNotification.id == 'Default' ?
                        <>
                            <input
                                className='form-control form-input'
                                name="department"
                                value={'Default'}
                                disabled={true}
                            />
                            <label>Name</label>
                        </>
                        :
                        <>
                            <Select
                                options={filteredDepartmentOptions}
                                name="department"
                                value={departmentOptions?.find(option => option.value == sickNotification.department)}
                                placeholder="Choose one..."
                                isDisabled={disabled}
                                onChange={(selected) => {
                                    updateSetting('department', selected.value)
                                }}
                            />
                            <label>Department</label>
                        </>
                    }
                </div>
            </div>
            <div className="col-sm-4 pl-0">
                <div className="form-material">
                    <input
                        className='form-control form-input'
                        name="period"
                        value={sickNotification?.period}
                        defaultValue={sickNotification?.period}
                        onChange={(e) => {
                            updateSetting(e.target.name, validateInteger(e.target.value))
                        }}
                        disabled={disabled}

                    />
                    <label>Minimum Days</label>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    const departmentOptions = state?.company?.settings?.departments?.map(dep => ({
        value: dep.id,
        label: dep.name,
    }))

    const usedDepartments = cleanDeep(state?.leave?.leaveSettings?.sickNotificationPeriods?.map(period => period.department))

    return {
        departmentOptions,
        filteredDepartmentOptions: departmentOptions?.filter((department) => { return usedDepartments?.indexOf(department.value) == -1; }),
        disabled:( state?.permissions?.my?.permissions?.settings == 'Read') || (state?.company?.settings?.status == 'Archived')
    }
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    updateSetting: (field, newValue) => dispatch(ACTIONS.updateSetting(field, newValue, 'sickNotificationPeriods', ownProps?.sickNotification?.id))
});

export default connect(mapStateToProps, mapDispatchToProps)(SickNotificationPeriod);